module.exports = __webpack_public_path__ + "media/images/partners/wizart.ua-4cfb08398dc2d3e232e717f8d6651b3d.png";